import React from "react";
import { useEffect,useState } from "react";
import Hero1 from "./themes/hero1";




export default function HeroSectionFunc({list}){



return(
    <Hero1  list={list}/>
)

}





